import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, UrlTree,} from '@angular/router';
import {Observable, of} from 'rxjs';
import {AppService} from './app.service';
import {JsonLogin, MemberRole} from 'src/model/dto';
import {catchError, map} from 'rxjs/operators';
import {MessageService} from "primeng/api";
import {SeverityEnum, ToastMsg} from "../model/page";
import {KeepAliveService} from "./utility/keep-alive.service";

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    private appService: AppService,
    private router: Router,
    private msgService: MessageService,
    private keepAliveService: KeepAliveService) {}

  canActivate(routeSnapshot: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    let loginInfo: JsonLogin = this.appService.loginInfo;

    if (!loginInfo && localStorage.getItem('loginInfo')) {
      console.log('AuthGuardService: Restoring loginInfo from localStorage');
      loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
      this.appService.loginInfo = loginInfo;
    }

    if (!loginInfo) {
      console.log('AuthGuardService: No loginInfo, redirecting to login');
      return of(this.router.createUrlTree(['login']));
    }

    console.log('AuthGuardService: Verifying token...');
    return this.appService
      .get('auth', 'verifyToken', { token: loginInfo.token })
      .pipe(
        map((res: JsonLogin) => {
          if (res && res.id) {
            console.log('AuthGuardService: Token verified successfully');
            // 驗證成功，更新 loginInfo
            this.appService.loginInfo = res;
            localStorage.setItem('loginInfo', JSON.stringify(res));
            console.log('AuthGuardService: Calling keepAliveService.start()');
            this.keepAliveService.start();

            const isAdminRoute = routeSnapshot.url.toString().includes('admin');
            const isAdminUser = res.role === MemberRole.admin;

            if (isAdminRoute && !isAdminUser) {
              this.msgService.add(new ToastMsg(SeverityEnum.error, 'Permission Denied', 'You do not have permission to access Admin page.'));
              return this.router.createUrlTree(['login']);
            }
            return true;
          } else {
            this.msgService.add(new ToastMsg(SeverityEnum.error, 'Login Expired', 'Please login again.'));
            return this.router.createUrlTree(['login']);
          }
        }),
        catchError((err) => {
          // token 驗證時出錯，導回 login
          this.msgService.add(new ToastMsg(SeverityEnum.error, 'Login Verification Failed', 'Please login again.'));
          return of(this.router.createUrlTree(['login']));
        })
      );
  }
}
